<template>
    <form class="form p-0" v-if="useDvFlag('beepiz-action-point-can:create')">
        <h2 class="text-xl font-semibold mt-0 mb-4">{{ formTitle }}</h2>
        <div class="form-row row special-photo-input">
            <PhotoInput
                    id="APPhoto"
                    ref="APPhoto"
                    accept="image/jpeg,image/png,image/gif"
                    margin="0"
                    width="500"
                    height="200"
                    size="2"
                    buttonClass="action-button"
                    removeButtonClass="action-button"
                    :crop="false"
                    :removable="true"
                    :customStrings="{
                                        upload: $t('global.form.pictureinput.upload'),
                                        drag: $t('global.form.pictureinput.drag'),
                                        tap: $t('global.form.pictureinput.tap'),
                                        change: $t('global.form.pictureinput.change'),
                                        remove: $t('global.form.pictureinput.remove'),
                                        select: $t('global.form.pictureinput.select'),
                                        selected: $t('global.form.pictureinput.selected'),
                                        fileSize: $t('global.form.pictureinput.fileSize'),
                                        fileType: $t('global.form.pictureinput.fileType'),
                                        aspect: $t('global.form.pictureinput.aspect')
                                    }"
                    @change="onPhotoSelect"
                    @error="handlePhotoError"
            >
            </PhotoInput>
        </div>
        <div class="form-row row">
            <label class="col-4">{{ $t('ap.library.form.label') }}</label>
            <input type="text" v-model="ap.name" name="label"
                   class="form-input col" v-validate
                   data-vv-rules="required" :data-vv-as="$t('ap.library.form.label')"
                   data-vv-validate-on="none"/>
            <span class="form-input-error" v-show="showErrors['label'] && errors.has('label')"
                  @click="hideError('label')">{{ errors.first('label') }}</span>
        </div>
        <div class="form-row row">
            <label class="col-4">
                {{ $t('ap.library.form.type') }}
            </label>
            <select class="form-input col" v-model="ap.type" name="type" v-validate
                    data-vv-rules="required" :data-vv-as="$t('ap.library.form.type')"
                    data-vv-validate-on="none" @change="handleTypeChange"
                    style="font-family: 'FontAwesome','Material-Design-Iconic-Font',Arial;">
                <option value=""></option>
                <option v-for="n in [1,2,3,4,5]" :value="n"
                        style="font-family: 'FontAwesome','Material-Design-Iconic-Font',Arial;"
                        v-html="icons(n)+'&nbsp;&nbsp;&nbsp;'+$t(typeLabel(n))"></option>
            </select>
            <span class="form-input-error" v-show="showErrors['type'] && errors.has('type')"
                  @click="hideError('type')">{{ errors.first('type') }}</span>
        </div>
        <div class="form-row row" v-show="ap.type != 4">
            <label class="col-4">
                {{ $t('ap.library.form.serial') }}&nbsp;&nbsp;&nbsp;<i class="fa fa-question-circle" v-show="ap.type == 2 || ap.type == 5" @mouseover="showTooltipBeacon" @mouseout="hideTooltipBeacon"></i>
                <div class="tooltip left" style="width: 250px;top: 7px; left: 110px;" :class="{show:showTooltip.beacon}">{{ beaconTooltipContent }}</div>
            </label>
            <input type="text" v-model="ap.serial" name="serial"
                   class="form-input col" v-validate
                   data-vv-rules="required" :data-vv-as="$t('ap.library.form.serial')"
                   data-vv-validate-on="none"
                   v-inputmask="typeMask(ap.type)"/>
            <span class="form-input-error" v-show="showErrors['serial'] && errors.has('serial')"
                  @click="hideError('serial')">{{ errors.first('serial') }}</span>
        </div>
        <div class="form-row row">
            <div class="col-4">
                <label>
                    <div>
                        {{ $t('ap.library.form.comment') }}<br>
                        <!-- TOOLTIP -->
                        <span class="relative">
                            <i class="fa fa-question-circle text-warning warning-beepiz-remote-monitoring show"></i>
                            <div class="tooltip left" style="width: 250px;top: -2px; left: 37px;">
                               {{ $t('ap.library.tooltip.content', {univers: Utils().getApplicationName()}) }}
                            </div>
                        </span>
                        <!-- TOOLTIP END-->
                    </div>
                </label>
                </div>
            <textarea class="form-input col" v-model="ap.comment" v-validate
                      data-vv-rules="max:512" :data-vv-as="$t('ap.library.form.comment')"
                      data-vv-validate-on="none"></textarea>
            <span class="form-input-error" v-show="showErrors['comment'] && errors.has('comment')"
                  @click="hideError('comment')">{{ errors.first('comment') }}</span>
        </div>
<!--        <div class="form-row row">-->
<!--            <label class="col-4">{{ $t('ap.library.form.notification') }}</label>-->
<!--            <textarea class="form-input col" v-model="ap.notification" v-validate-->
<!--                      data-vv-rules="max:512" :data-vv-as="$t('ap.library.form.notification')"-->
<!--                      data-vv-validate-on="none"></textarea>-->
<!--            <span class="form-input-error" v-show="showErrors['notification'] && errors.has('notification')"-->
<!--                  @click="hideError('notification')">{{ errors.first('notification') }}</span>-->
<!--        </div>-->
    </form>
</template>

<script>
    import Vue from 'vue';
    import PhotoInput from '@/components/ui/PictureInput';
    import FormUtils from '@/services/form.js';
    import Rules from '@/services/apRules.js';
    import Icons from "@/services/iconMapping.js";
    import VInputmask from 'v-inputmask';

    import API from '@/services/API.js';

    import axios from 'axios';
    import Utils from "@/services/utils.js";
    import {useDvFlag} from "../../../services/featureFlag";

    Vue.use(VInputmask);

    var userPlaceholderG = require("@/assets/img/user-no-img.png");

    export default {
        components: {
            PhotoInput
        },
        computed: {
            formTitle: function () {
                if (this.editMode) {
                    return window.V.$i18n.t('ap.titles.libraryformedit');
                }
                else {

                    return window.V.$i18n.t('ap.titles.libraryformadd');
                }
            },
            beaconTooltipContent: function(){
                if(this.ap.type == 2 || this.ap.type == 5){
                    return Utils.t('ap.library.form.serialBeaconHelper'+this.ap.type);
                }
                return '';
            },
            errors: function(){
                return this.$validator.errorBag
            }
        },
        data () {
            return {
                userPlaceholder: userPlaceholderG,
                editMode: false,
                tempSerialValue: "",
                tags: [],
                ap: {
                    picture: '',
                    type: '',
                    name: '',
                    serial: '',
                    comment: '',
                    notification: '',
                    tags: [],
                    tagsOptions: [
                        {tag:'Test1'},
                        {tag:'Test2'},
                        {tag:'Test3'},
                        {tag:'Test4'},
                    ]
                },
                showErrors: {
                    picture: false,
                    type: false,
                    label: false,
                    serial: false,
                    comment: false,
                    notification: false,
                    tags: false
                },
                showTooltip: {
                    beacon: false,
                }
            }
        },
        methods: {
          useDvFlag,
          Utils() {
            return Utils
          },
            addTag: function (newTag) {
                const tag = {
                    tag: newTag
                }
                this.ap.tagsOptions.push(tag)
                this.ap.tags.push(tag)
            },
            handleTypeChange: function(){
                if(this.ap.type == 4){ // Cas particulier du QRCOde pour lequel on ne saisit pas le serial
                    this.ap.serial = "#QRCode#";
                }
            },
            populateForm: function (apToEdit) {
                this.editMode = true;
                if(this.errors){
                    this.errors.clear();
                }

                //HACK pour problème de conflit sur le champ serial entre v-model et v-inputmask
                this.tempSerialValue = apToEdit.serial;
                delete apToEdit.serial;
                this.ap = apToEdit;
                setTimeout(()=>{
                    Vue.set(this.ap, 'serial', this.tempSerialValue);
                },1)


                if(apToEdit.picture != null){
                    var file = Utils.dataURLtoFile(apToEdit.picture);
                    var event = {
                        target: {
                            files: [
                                file
                            ]
                        }
                    }
                    this.$refs.APPhoto.onFileChange(event);
                }
                else{
                    this.$refs.APPhoto.removeImage();
                }

                this.ap.tags = [];
                this.ap.tagsOptions = [];
            },
            validateForm: function () {
                FormUtils.hideAllErrors(this);

                this.$validator.validateAll().then(() => {
                    this.saveForm();
                }).catch((error) => {
                    FormUtils.showAllErrors(this);
                    this.$emit('error');
                });
            },
            saveForm: function () {
                var apToEdit = Vue.util.extend({}, this.ap)
                var id = apToEdit.id;
                this.transformer(apToEdit);
                if (this.editMode) {
                    axios.put(API.route(API.endpoints.actionpoints.edit, {apId: id}), apToEdit)
                        .then(response => {
                            this.resetForm();
                            window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                            this.$emit('saved');
                        })
                        .catch(error => {
                            if (error.response != null) {
                                var errorBag = this.$validator.errorBag;
                                if (error.response.status == 422) {
                                    if(typeof error.response.data.message === 'object'){
                                        FormUtils.handleErrors(errorBag, error.response.data.message)
                                    }
                                    else{
                                        window.Vfc.$refs.messages.sendMessage('error', error.response.data.message);
                                    }

                                }
                                FormUtils.showAllErrors(this);
                                this.$emit('error');
                            }
                            else {
                            }
                        })
                }
                else {
                    axios.post(API.endpoints.actionpoints.add, apToEdit)
                        .then(response => {
                            this.resetForm();
                            window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                            this.$emit('saved',response.data.message);
                        })
                        .catch(error => {
                            if (error.response != null) {
                                var errorBag = this.$validator.errorBag;
                                if (error.response.status == 422) {
                                    if(typeof error.response.data.message === 'object'){
                                        FormUtils.handleErrors(errorBag, error.response.data.message)
                                    }
                                    else{
                                        window.Vfc.$refs.messages.sendMessage('error', error.response.data.message);
                                    }
                                }
                                FormUtils.showAllErrors(this);
                                this.$emit('error');
                            }
                            else {
                            }
                        })
                }
            },
            hasModifications: function () {
                if (this.ap.type != ''
                    || this.ap.name != ''
                    || this.ap.serial != ''
                    || this.ap.comment != ''
                    || this.ap.notification != ''
                ) {
                    return true;
                }
                return false;
            },
            transformer: function (ap) {
                if(!this.editMode && ap.type == 4){ // Cas particulier du QRCOde pour lequel on ne saisit pas le serial
                    ap.serial = "";
                }
                if(ap.type == 3){ // Cas particulier du NFC pour lequel on doit virer les reliquat du masque de saisie
                    ap.serial = ap.serial.replace(/_/g,'');
                }
                delete ap.id;
                delete ap.tags;
                delete ap.selected;
                delete ap.firstTime;
                delete ap.tagsOptions;
                delete ap.show;
                delete ap.opened;
                delete ap.active;
                delete ap.polygon;
                delete ap.x;
                delete ap.y;
                delete ap.plans;
                delete ap.radiance;
                delete ap.patrols;
                delete ap.last_detection_at;
                delete ap.battery;
            },
            resetForm: function () {
                this.editMode = false;
                this.$refs.APPhoto.removeImage();
                this.ap = {
                    picture: '',
                    type: '',
                    name: '',
                    serial: '',
                    comment: '',
                    notification: '',
                    tags: [],
                    tagsOptions: []
                };
                FormUtils.hideAllErrors(this);
            },
            hideError: function (key) {
                FormUtils.hideError(this, key);
            },
            typeLabel: function (typeId) {
                return 'ap.types.' + Rules.realLabels[typeId];
            },
            typeMask: function (typeId) {
                return Rules.typesMasks[typeId];
            },
            icons: function (typeId) {
                return Icons.actionpointsSelect[Rules.types[typeId]];
            },
            onPhotoSelect: function(){
                this.ap.picture = this.$refs.APPhoto.image;
            },
            handlePhotoError: function(response){
                window.Vfc.$refs.messages.sendMessage('error', response.message);
            },
            showTooltipBeacon: function(){
                this.showTooltip.beacon = true;
            },
            hideTooltipBeacon: function(){
                this.showTooltip.beacon = false;
            },
        },
        mounted: function () {
          const flag = useDvFlag('beepiz-action-point-can:read');
          if (!flag.access && flag.fallback==="no_plan") {
            this.$router.push({ name: 'AccessDenied', params: { slug: "actionpoints-library"} })
          }
          else if (!flag.access && flag.fallback==="no_role") {
            this.$router.push({ name: 'AccessDenied', params: { slug: "actionpoints-library_no_role"} })
          }
        },
        name: '',
        props: [],
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss" scoped>

</style>
